// Resultatregnskap og saldobalanse (no).
window.PlummeI18n.register('no', {
  'rep.zeroHidden': 'Kontoene har nullsaldo i valgt periode. Vis dem via Filtervalg.',
  'rep.showZero': 'Vis kontoer med nullsaldo',
  'rep.group.tax': 'SKATTEKOSTNAD',
  'rep.group.dispositions': 'DISPONERINGER',
  'rep.trial.titleHelp': 'Saldobalansen lister alle kontoene i kontoplanen med saldo for valgt periode. Trykk på en kontolinje for å se bilagene som er ført på kontoen.',
  'rep.trial.viewHelp': 'Saldobalansen viser som standard bare aktive konti — konti med saldo eller bevegelse. «Vis også inaktive konti» tar med resten av kontoplanen, og «Vis kun konti med bevegelse» krever at kontoen er ført i perioden. Vis som velger om beløpene vises i kroner og øre, hele kroner eller hele tusen.',
  'rep.trial.empty': 'Ingen bokførte saldoer for valgt periode.',
  'rep.trial.oneSupplier': '1 leverandør',
  'rep.trial.supplierCount': '{n} leverandører',
  'rep.trial.oneCustomer': '1 kunde',
  'rep.trial.customerCount': '{n} kunder',
  'rep.trial.oneOpenCustomerItem': '1 åpen post',
  'rep.trial.openCustomerItems': '{n} åpne poster',
  'rep.trial.customerDifference': 'Andre posteringer / avstemmingsdifferanse',
  'rep.trial.noCustomerBalances': 'Ingen kundesaldoer i valgt visning.',
  'rep.trial.oneOpenSupplierItem': '1 åpen post',
  'rep.trial.openSupplierItems': '{n} åpne poster',
  'rep.trial.supplierDifference': 'Andre posteringer / avstemmingsdifferanse',
  'rep.trial.noSupplierBalances': 'Ingen leverandørsaldoer i valgt visning.',
  'rep.trial.exportTitle': 'Saldobalanse: {column}',
  'rep.group.assets': 'EIENDELER',
  'rep.group.equityLiabilities': 'EGENKAPITAL / GJELD',
  'rep.group.operatingIncome': 'DRIFTSINNTEKTER',
  'rep.group.operatingCosts': 'DRIFTSKOSTNADER',
  'rep.groupTotal': 'Sum {group}',
  'rep.balance.opening': 'Inngående',
  'rep.balance.movement': 'Endring',
  'rep.balance.closing': 'Utgående',
  'rep.showAs.withDecimals': 'Kroner og øre',
  'rep.showAs.whole': 'Hele kroner',
  'rep.showAs.thousands': 'Hele tusen',
  'rep.result.titleHelp': 'Resultatregnskapet viser inntektene og kostnadene i perioden, og hva som blir igjen som resultat. Åpne en seksjon for å se kontoene bak tallene, og trykk på en kontolinje for å se bilagene som er ført der.',
  'rep.result.subtitle': 'Start med oppsummering, og åpne kontodetaljer ved behov.',
  'rep.result.income': 'Driftsinntekter',
  'rep.result.costs': 'Driftskostnader',
  'rep.result.finance': 'Finans',
  'rep.result.beforeTax': 'Resultat før skatt',
  'rep.result.noLines': 'Ingen aktivitet på disse kontoene ennå.',
  'rep.total': 'Sum',
  'rep.showDetails': 'Vis detaljer',
  'rep.hideDetails': 'Skjul detaljer',
  'rep.shareOfLargest': '{pct} % av største post',
  'rep.showVouchersFor': 'Vis alle bilag på {account}',
  'rep.period.otherYear': 'Viser tall for regnskapsåret {year}.',
  'rep.period.singleYear': 'Perioden går over to regnskapsår. Rapporten regnes per regnskapsår med inngående balanse fra årsstart, så velg en periode innenfor ett år.',
  'rep.export.busy': 'Eksporterer...',
  'rep.export.downloaded': '{format} lastet ned',
  'rep.export.failed': 'Kunne ikke eksportere rapporten.',
  'rep.export.pdfUnavailable': 'Rapport-PDF er ikke koblet til backend.',
  'rep.export.year': 'År',
  'rep.export.period': 'Periode',
  'rep.export.summary': 'Oppsummering',
  'rep.export.item': 'Post',
  'rep.export.amount': 'Beløp',
  'rep.accountHelp.receivables': 'Kundefordringer er penger kunder skylder deg for fakturaer som ikke er betalt ennå.',
  'rep.accountHelp.bank': 'Bankinnskudd viser penger på driftskontoen.',
  'rep.accountHelp.payables': 'Leverandørgjeld er fakturaer og kjøp du skylder leverandører.',
  'rep.accountHelp.outputVat': 'Utgående MVA er merverdiavgift du har krevd inn ved salg.',
  'rep.accountHelp.inputVat': 'Inngående MVA er merverdiavgift du har betalt ved kjøp og normalt kan få fradrag for.',
  'rep.accountHelp.vatSettlement': 'Oppgjørskonto MVA viser netto MVA du skylder eller har til gode.',
  'rep.accountHelp.vatableSales': 'Salgsinntekt med MVA-plikt viser ordinært salg der det beregnes utgående MVA.',
  'rep.accountHelp.group.asset': 'Eiendelskonto: verdier foretaket eier eller har til gode.',
  'rep.accountHelp.group.equityLiability': 'Egenkapital eller gjeld: finansiering, skyldige beløp og oppgjørsposter.',
  'rep.accountHelp.group.income': 'Inntektskonto: salg og andre inntekter i virksomheten.',
  'rep.accountHelp.group.goods': 'Varekostnad: kostnader knyttet til varer, råvarer eller videresalg.',
  'rep.accountHelp.group.payroll': 'Lønnskostnad: lønn, feriepenger og personalrelaterte ytelser.',
  'rep.accountHelp.group.operating': 'Driftskostnad: kostnader ved å drive virksomheten.',
  'rep.accountHelp.group.finance': 'Finans- eller skattekonto: renter, finansposter eller skattekostnad.',
  'rep.accountHelp.other': 'Konto {account} i kontoplanen.',
  'rep.accountHelp.openVouchers': 'Trykk på kontolinjen for å se alle bilag som er ført på denne kontoen.',
  'rep.dimensions.title': 'Prosjekt og avdeling',
  'rep.dimensions.help': 'Filtrer rapporten uten å endre kildedata. Hele bilaget beholdes, inkludert motpostene.',
  'rep.dimensions.project': 'Prosjekt',
  'rep.dimensions.department': 'Avdeling',
  'rep.dimensions.all': 'Alle',
  'rep.dimensions.unassigned': 'Ikke fordelt',
  'rep.incompleteBasisTitle': 'Regnskapsgrunnlaget er ufullstendig',
  'rep.journalLoading': 'Henter regnskapsjournalen …',
  'rep.incompleteBasisText': 'Rapporten vises ikke som komplett fordi journaldekningen eller nødvendig inngående grunnlag ikke er dokumentert. Tilgjengelige data er bevart for kontroll.',
  'rep.importedBasisTitle': 'Importert regnskapsstatistikk.',
  'rep.importedBasisText': 'Tallene kommer fra kontrollert importert kontostatistikk, ikke journalhendelser i Plumme. De er ikke sertifisert og kan ikke brukes til innsending, betalingsgodkjenning eller årsavslutning.',
  'rep.importedBasisExport': 'Kontrollert importert kontostatistikk; ikke journalfullstendig eller sertifisert.',
});
